/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, Menu, Spin } from 'antd';
import { MenuKeys } from 'common/enums/MenuKeys';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGetUserQuery } from 'redux/services/cookieMonster/cookieMonsterApi';

const styles: InlineStylesModel = {
  dropDown: {
    cursor: 'pointer'
  },
  menu: {
    alignItems: 'center',
    background: 'none',
    borderRight: 'none',
    display: 'flex',
    marginLeft: '8px'
  },
  menuIcon: {
    color: 'rgb(132, 133, 154)',
    fontSize: '18px',
    marginLeft: '5px'
  }
};

export const UserDropdown = (): JSX.Element => {
  const { logout, user } = useAuth0();
  const history = useHistory();

  const { data: userData, isLoading, isFetching } = useGetUserQuery(user?.sub as string, { skip: !user?.sub });

  const menu = (
    <Menu disabledOverflow={true}>
      <Menu.Item onClick={(): void => history.push('/about')} key={MenuKeys.about}>
        {MenuKeys.about}
      </Menu.Item>
      <Menu.Item onClick={(): void => history.push('/profile')} key={MenuKeys.profile}>
        {MenuKeys.profile}
      </Menu.Item>
      <Menu.Item key={MenuKeys.logout} onClick={(): void => logout({})}>
        {MenuKeys.logout}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Avatar
        style={{ marginLeft: 8, cursor: 'pointer' }}
        src={userData && userData.user_metadata.profile_image_url ? userData.user_metadata.profile_image_url : !(isLoading || isFetching) ? user?.picture : <Spin />}
      />
    </Dropdown>
  );
};
